import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, filter, switchMap, take } from "rxjs/operators";
import { AuthService } from "../auth.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(public authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isAuthRoute = request.url.includes("Auth");
        const isS3Route = request.url.toLowerCase().includes("s3");
        const isVindi = request.url.toLowerCase().includes("vindi");
        const isRelativeRoute = !request.url.startsWith("http");
        const isPublicRoute = window.location.pathname.startsWith("/public/");

        if (isAuthRoute || isS3Route || isRelativeRoute || isPublicRoute || isVindi) {
            return next.handle(request);
        }

        const accessToken = this.authService.getAccessToken();

        if (accessToken) {
            request = this.addToken(request, accessToken);
        }

        return next.handle(request).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                } else {
                    return throwError(error);
                }
            })
        );
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.applyRefreshToken(this.authService.getCurrentSubscriptionId(), false).pipe(
                switchMap((refresh: any) => {
                    this.isRefreshing = false;
                    if (!refresh.success) {
                        this.refreshTokenSubject.next(null);
                        this.logoutAndRedirect();
                        return throwError(new Error('Token refresh failed'));
                    } else {
                        const accessToken = this.authService.getAccessToken();
                        this.refreshTokenSubject.next(accessToken);
                        return next.handle(this.addToken(request, accessToken));
                    }
                }),
                catchError((e) => {
                    this.isRefreshing = false;
                    console.log("Refresh token error: ", e);
                    this.logoutAndRedirect();
                    return throwError(e);
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter((token) => token != null),
                take(1),
                switchMap((jwt) => {
                    return next.handle(this.addToken(request, jwt));
                })
            );
        }
    }

    private logoutAndRedirect(): void {
        const currentUrl = this.router.url;
        this.authService.logout().subscribe(() => {
            // Redireciona para login com callback para a página atual
            this.router.navigate(["/"], { 
                queryParams: { callbackUrl: currentUrl } 
            });
        });
    }
}

// @Injectable()
// export class RequestInterceptor implements HttpInterceptor {
//   private refreshTokenInProgress: boolean;

//   // o refresh token Subject rastreia o token atual ou é nulo se não houver token
//   private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
//     null
//   );

//   constructor(private auth: AuthService, private router: Router) {
//     this.refreshTokenInProgress = false;
//   }

//   intercept401(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     console.log("intercept401");

//     var result = next.handle(request);
//     console.log(result);

//     return result;

//     // return next.handle(this.addAuthenticationToken(request)).pipe(
//     //   tap(
//     //     (d) => {
//     //       console.log(d);
//     //     },
//     //     (error) => {
//     //       console.log(error);
//     //     }
//     //   )
//     // );

//     // return next.handle(this.addAuthenticationToken(request)).pipe(
//     //   tap(
//     //     () => {
//     //       console.log("success??");

//     //       this.refreshTokenInProgress = false;
//     //       this.refreshTokenSubject.next(token);
//     //     },
//     //     (error) => {
//     //       this.refreshTokenInProgress = false;
//     //       console.log("refresh error? ", error);

//     //       if (error.status != "401") return;

//     //       this.auth
//     //         .logout()
//     //         .toPromise()
//     //         .then(() => {
//     //           this.router.navigate(["/"]);
//     //         });
//     //     }
//     //   )
//     // );
//   }

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     const isAuthRoute = request.url.includes("Auth");
//     const isS3Route = request.url.toLowerCase().includes("s3");
//     const isRelativeRoute = !request.url.startsWith("http");

//     if (isAuthRoute || isS3Route || isRelativeRoute) {
//       return next.handle(request);
//     }

//     return next.handle(this.addAuthenticationToken(request)).pipe(
//       tap(
//         () => {},
//         (error) => {
//           if (error.status != "401") return;

//           console.log(
//             "this.refreshTokenInProgress",
//             this.refreshTokenInProgress
//           );

//           console.log(
//             "this.refreshTokenSubject.value",
//             this.refreshTokenSubject.value
//           );

//           if (this.refreshTokenInProgress) {
//             // se estamos usando o refresh token, aguardaremos para que possa ser utilizado na chamada novamente
//             return this.refreshTokenSubject.pipe(
//               filter((result) => result != null),
//               take(1),
//               switchMap(() =>
//                 this.intercept401(this.addAuthenticationToken(request), next)
//               )
//             );
//           } else {
//             this.refreshTokenInProgress = true;
//             this.refreshTokenSubject.next(null);

//             // seria interessante utilizar Observable, mas toPromisse funcionou mais fácil :)
//             this.auth
//               .refreshToken()
//               .toPromise()
//               .then((token: any) => {
//                 if (token) {
//                   this.refreshTokenInProgress = false;
//                   this.refreshTokenSubject.next(token);

//                   return this.intercept401(
//                     this.addAuthenticationToken(request),
//                     next
//                   );
//                 } else {
//                   this.auth
//                     .logout()
//                     .toPromise()
//                     .then(() => {
//                       this.router.navigate(["/"]);
//                     });
//                 }
//               })
//               .catch(() => {
//                 this.refreshTokenInProgress = false;

//                 this.auth
//                   .logout()
//                   .toPromise()
//                   .then(() => {
//                     this.router.navigate(["/"]);
//                   });
//               });
//           }
//         }
//       )
//     );
//   }

//   private addAuthenticationToken(request) {
//     const accessToken = this.auth.getAccessToken();

//     // se não tem nada na storage então tentaremos a requisição original
//     if (!accessToken) {
//       return request;
//     }

//     return request.clone({
//       setHeaders: {
//         Authorization: `Bearer ${this.auth.getAccessToken()}`,
//       },
//     });
//   }
// }
